<template>
  <CourseBlock
    id="rating"
    class="rating"
  >
    <template #title>
      Оценка:
      <svg-icon
        name="basic/ui-star-filled"
        width="24"
        height="24"
        class="rating__value-icon"
        aria-hidden="true"
      />
      {{ rating.value }}
      от&nbsp;студентов курса
    </template>

    <template #content>
      <ul class="rating__review-list">
        <li
          v-for="(card, i) in slicedCards"
          :key="i"
          class="rating__review-item"
        >
          <UiReviewCard
            :user="card.author"
            :review="card.review"
            class="rating__review"
          />
        </li>
      </ul>

      <UiButton
        v-if="cards.length > 2"
        theme="quaternary"
        size="big"
        stretch
        @click="isExpanded = !isExpanded"
      >
        {{ isExpanded ? 'Скрыть' : 'Показать ещё' }}
      </UiButton>
    </template>
  </CourseBlock>
</template>

<script setup lang="ts">
  import UiButton from '@academica-box/components/Buttons/UiButton/UiButton.vue'
  import UiReviewCard from '@academica-box/components/Cards/UiReviewCard/UiReviewCard.vue'
  import type { VendorReview } from '@academica-box/types'

  const props = defineProps<{
    rating: {
      value: string | number;
    }
    cards: VendorReview[];
  }>()

  const isExpanded = ref(false)

  const slicedCards = computed(() => {
    return isExpanded.value ? props.cards : [...props.cards].splice(0, 2)
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;
  @use '@academica-box/utils/styles/mixins/UiReset' as *;

  .rating__title {
    @include media(md-max) {
      max-width: 314px;
      margin-bottom: 24px;
    }

    @include media(lg) {
      margin-bottom: 40px;
    }
  }

  .rating__value-icon {
    position: relative;
    top: 3px;
    width: 24px;
    height: 24px;
    color: var(--accent-rating-color);

    @include media(lg) {
      top: 6px;
      width: 40px;
      height: 40px;
    }
  }

  .rating__review-list {
    @include ulres;

    display: grid;
    grid-gap: 6px 6px;

    @include media(md) {
      grid-template-columns: 1fr 1fr;
    }

    @include media(lg) {
      grid-template-columns: none;
    }

    @include media(xxl) {
      grid-template-columns: 1fr 1fr;
    }

    &:not(:last-child) {
      margin-bottom: 20px;

      @include media(lg) {
        margin-bottom: 32px;
      }
    }
  }

  .rating__review {
    height: 100%;
  }
</style>
